import { useEffect } from "react";

// Every write to document.body.style.overflow (bottom sheets, the mobile search
// overlay, the loading splash) goes through this counter. Locks often overlap,
// e.g. a menu sheet opening a form sheet while it animates out, so only the
// first lock saves the page's overflow and only the last one restores it.
// Radix modals, drawers and dropdowns lock scroll separately via
// react-remove-scroll (a body attribute and stylesheet with its own counter),
// which never touches the inline style, so the two can't clash.
let scrollLocks = 0;
let unlockedOverflow = "";

export const useScrollLock = (isLocked: boolean) => {
  useEffect(() => {
    if (!isLocked) return;

    if (scrollLocks++ === 0) {
      unlockedOverflow = document.body.style.overflow;
      document.body.style.overflow = "hidden";
    }

    return () => {
      if (--scrollLocks === 0) document.body.style.overflow = unlockedOverflow;
    };
  }, [isLocked]);
};
